import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page.component';
import { ActionPlanModel, Person } from '../../shared/models/index';
import { ActionPlanService, PeopleService, AccessRightsService } from '../../shared/services/index';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
    selector: 'action-plan-collaborate',
    templateUrl: 'collaborate.component.html',
    standalone: false
})
export class ActionPlanCollaboratePageComponent extends BasePageComponent implements OnInit {
  public actionPlan: ActionPlanModel;
  public actionPlanId: string;
  public processing = false;
  public columns: string[] = ['Read', 'Write', 'Comment'];
  public people: Person[];
  public accessRights: any[];

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private actionPlanService: ActionPlanService,
    private peopleService: PeopleService,
    private accessRightsService: AccessRightsService,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) {
        this.router.navigate([this.actionPlansRoute]);
      }
      this.actionPlanId = id;

      this.actionPlanService.getActionPlan(this.actionPlanId).subscribe((data) => {
        this.actionPlan = data;
      });

      this.peopleService.getPeople().subscribe((data) => {
        this.people = data;
      });

      this.accessRightsService.getRights('actionPlans', this.actionPlanId).subscribe((data) => {
        this.accessRights = data;
      });
    });
    this.cdf.detectChanges();
  }

  save(accessRights: any) {
    this.processing = true;
    this.accessRightsService.updateRights('actionPlans', this.actionPlanId, accessRights).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }
}
